<template>
  <div class="auth-form">
    <div class="auth-form__title">Sign in</div>
    <div>
      <v-btn
        block
        dark
        x-large
        color="#dc4b3d"
        elevation="0"
        @click="oauth('google')"
      >
        Sign in with Google
      </v-btn>
      <br />
      <v-btn
        block
        dark
        x-large
        color="#4267b2"
        elevation="0"
        @click="oauth('facebook')"
      >
        Sign in with Facebook
      </v-btn>
      <br />
      <v-btn
        block
        dark
        x-large
        color="#55abef"
        elevation="0"
        @click="oauth('twitter')"
      >
        Sign in with Twitter
      </v-btn>
      <br />
      <v-btn
        block
        dark
        x-large
        color="#0177b5"
        elevation="0"
        @click="oauth('linkedin')"
      >
        Sign in with LinkedIn
      </v-btn>
      <br />
      <small>
        <div>
          * Authentication is only required if you wish to use the chat feature.
          All videos and memory posts will be public to all.
        </div>
      </small>
    </div>
  </div>
</template>

<script>
import formMixin from "@/mixins/form.mixin";

export default {
  name: "Login",
  extends: formMixin,
  data() {
    return {
      form: {}
    };
  },
  methods: {
    async submit() {
      await this.$recaptchaLoaded();
      this.form.recaptcha = await this.$recaptcha("login");

      if (!this.validate() || !this.form.email || !this.form.password) return;

      await this.$store.dispatch("auth/login", this.form);

      this.$emit("close");
    },
    async oauth(provider) {
      const { token } = await this.$auth.authenticate(provider);
      this.$store.commit("auth/setToken", token);
      await this.$store.dispatch("user/fetch");

      const connectionUrl =
        location.origin.replace("http", "ws") +
        "/cable" +
        (token ? `?token=${token}` : "");

      this.$cable._cable._url = connectionUrl;
      this.$cable._connectionUrl = connectionUrl;
      this.$cable.connection.disconnect();
      this.$cable.connection.connect();

      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
@import "./auth.scss";
</style>
